export default "__VITE_ASSET__CT5SvUH___"